import Card from './Card';
import Badge from './Badge';
import Button from './Button';
import BarBottomActions from './BarBottomActions';
import Tooltip from './Tooltip';
import Switch from 'components/SwitchCommon';
import NumberFormat from './NumberFormat';
import CountDown from './Countdown';
import Typography from './Typography';
import BoxWithShowHide from './BoxWithShowHide';
import Alert from './Alert';
import ButtonDropDown from './ButtonDropdown';
import Popover from './Popover';
import ExpandCollapseText from './ExpandCollapse';
import AudioPlayer from './AudioPlayer';
import SectionLabelContainer from './SectionLabelContainer';
import Dropdown from './Dropdown';
import Progress from './Progress';
import Accordion from './Accordion';
import FlashContainer from './FlashContainer';
import Dialog from './Dialog';
import Separator from './Separator';

const NewDesign = {
  AudioPlayer,
  Card,
  Badge,
  Button,
  BarBottomActions,
  Tooltip,
  Switch,
  NumberFormat,
  CountDown,
  Typography,
  BoxWithShowHide,
  Alert,
  ButtonDropDown,
  Popover,
  ExpandCollapseText,
  SectionLabelContainer,
  Dropdown,
  Progress,
  Accordion,
  FlashContainer,
  Dialog,
  Separator,
};

export default NewDesign;
